import {
  ChapterResources,
  ChapterTopicInfoV2,
  CourseIndexInfo,
  FetchSubjectChapterInfoV2,
} from '@protos/content_management/content.common.apis_pb';
import {
  AssessmentEnum,
  ChapterIdsInfo,
  CloudUpload,
  MarkingSchemeEnum,
  ModeOfConductionEnum,
  MultiSubjectSubSection,
  QuestionModuleMap,
  QuestionPaperTemplate,
  QuestionTypeMarks,
  TaskCreationStatusEnum,
  TaskInfo,
} from '@protos/learning_management/lms.db_pb';
// import {
//   ModuleFilteredQuestions,
//   QuestionStatsList,
//   TaskInfoModel,
// } from '@protos/learning_management/lms.hw.teacher.apis_pb';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { calculateQuestionsCount } from '../../Homework/ReviewHomework/functions';
import {
  AssessmentContent,
  AssessmentsByType,
  AssessmentTask,
} from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  ModuleFilteredQuestions,
  ModuleFilteredQuestionsV3,
  QuestionStatsList,
  SubSectionQuestionType,
  SubSectionType,
  TaskInfoModel,
  TeacherAssessAssignmentSubmit,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import {
  BloomLevelEnum,
  Question,
  Question_QuestionEnum,
} from '@protos/content_management/content.db_pb';
import {
  DifficutlyLevelQuestions,
  QuestionTypeCount,
} from '@protos/learning_management/lms.hw.teacher.apis_pb';
import { Interface } from 'readline';

interface Chapter {
  chapterId: number;
  chapterTitle: string;
  chapterNo: number;
}
interface IAssessmentCreationType {
  asessmentType?: AssessmentEnum;
  modeOfConduction: ModeOfConductionEnum;
  creationType?: 'Create' | 'Readymade';
  markingScheme?: MarkingSchemeEnum;
  assessmentName?: string;
}
interface Topic {
  topicId: number;
  topicTitle: string;
}
export interface IFAASSESSMENTCONFIG {
  noOfQuestions: number;
  approximateTime: number;
  overallDifficultyLevel: string;
  bloomLevels: BloomLevelEnum[];
  QuestionTypes: Question_QuestionEnum[];
  questionTypeCount?: QuestionTypeCount;
}
export interface IQPGSettingsConfig {
  overallDifficultyLevel: string;
  no_ofQuestions_by_types: QuestionTypeCount | undefined;
  no_ofQuestions_by_levels: DifficutlyLevelQuestions | undefined;
  bloomLevels: BloomLevelEnum[];
  question_type_marks: QuestionTypeMarks[];
  generate_sample_answer_paper?: boolean;
  allow_ai_questions?: boolean;
  prompt?: string;
  prompt_validated?: 'success' | 'error';
}
export interface IFASettingsConfig {
  no_of_questions?: number;
  approximate_time?: number;
  overall_difficulty?: string;
  marking_scheme?: MarkingSchemeEnum;
  bloom_levels?: BloomLevelEnum[];
  question_type_marks?: QuestionTypeMarks[];
  question_type_count?: QuestionTypeCount;
  question_types?: Question_QuestionEnum[];
}
export interface IQPGSeachQuestionsConfig {
  prompt?: string;
  prompt_validated?: 'success' | 'error';
}
interface IAssessmentTypes {
  name: string;
  id: AssessmentEnum;
}
export interface IAssessmentLibraryFilter {
  assessmentType?: IAssessmentTypes;
  assessmentCreationStatus?: string;
  CreatedBy?: string;
}
interface IQPGFormatDetails {
  selectedClass?: { name: string; id: number };
  selectedSubjectsAndMarks?: {
    subject: { name: string; id: number } | null;
    marks: number | undefined;
  }[];
  assessmentName?: string;
  selectedTemplates?: {
    name: string;
    id: number;
    subject?: { name: string; id: number };
  }[];
}

interface IFAFormatDetails {
  selectedClass?: { name: string; id: number };
  selectedSubjects?: { name: string; id: number }[];
  assessmentName?: string;
}
interface IQuestionUploadFilter {
  value: 'all' | 'teacher';
}
interface IFALibChoiceData {
  section_number?: number;
  subject_id?: number;
  marking_scheme?: MarkingSchemeEnum;
  conduction_mode?: ModeOfConductionEnum;
  chosen_assessment?: AssessmentTask;
}
export interface IAssessmentFlowState {
  question_upload_filter?: IQuestionUploadFilter;
  assesment_creation_type: IAssessmentCreationType;
  assesment_flow_data?: AssessmentsByType;
  chapter_topic_data?: CourseIndexInfo;
  fa_selected_chapter_data?: CourseIndexInfo;
  fa_assessment_config?: IFAASSESSMENTCONFIG;
  fa_edit_step?: 'chapterSelection' | 'settings' | undefined;
  fa_question_module_map?: QuestionModuleMap[];
  qpg_selected_chapter_data?: CourseIndexInfo;
  qpg_settings_config?: IQPGSettingsConfig;
  generated_qpg_templates?: QuestionPaperTemplate[];
  current_qpg_template_info?: QuestionPaperTemplate;
  qpg_edit_step?: 'chapterSelection' | 'settings' | 'addSection' | undefined;
  qpg_assessment_task?: AssessmentTask;
  qpg_assessment_content?: Question[];
  qpg_questions_sequence_info?: TaskInfo;
  qpg_questions_sequence_info_hash?: string;
  qpg_assessment_instructions_hash?: string;
  qpg_multi_subject_info_hash?: string;
  qpg_question_module_map?: QuestionModuleMap[];
  qpg_question_type_marks?: QuestionTypeMarks[];
  selected_section_index_for_alternate?: number;
  selected_question_index_for_alternate?: number;
  selected_question_type_for_alternate?: Question_QuestionEnum;
  selected_chapter?: Chapter;
  selected_topic?: Topic;
  questions_count: IRequiredQuestionCountInfoForDifficultyLevel;
  module_filtered_questions: ModuleFilteredQuestions | undefined;
  selected_tasks_info?: TaskInfoModel[] | undefined;
  filtered_questions: ModuleFilteredQuestions | undefined;
  subjectwise_chapters_info?: FetchSubjectChapterInfoV2;
  chapterwise_topic?: ChapterTopicInfoV2;
  chapter_resources?: ChapterResources;
  submitted_assessment_id?: number;
  created_assessment_details?: TeacherAssessAssignmentSubmit;
  createdAssessmentStatus?: TaskCreationStatusEnum;
  fetched_assessment_details?: AssessmentTask;
  questions_stats?: QuestionStatsList;
  assessment_instructions: string[];
  custom_homework?: AssessmentTask;
  draft_uploaded_files?: CustomUploadFileResponse[];
  temporary_section_ids?: number[];
  assessment_library_filter?: IAssessmentLibraryFilter;
  qpg_search_questions_config?: IQPGSeachQuestionsConfig;
  // manage_mode_of_conduction: ModeOfConductionEnum;

  // QPG V2
  qpg_format_details?: IQPGFormatDetails;
  qpg_subsection_data?: SubSectionType[];
  qpg_content?: AssessmentContent;
  qpg_selected_section_index?: number;
  qpg_selected_section_number?: number;
  qpg_created_section_test?: ModuleFilteredQuestionsV3;
  qpg_selected_sub_section_index?: number;
  qpg_chapter_ids_info_collection?: { [sectionNo: number]: ChapterIdsInfo[] };

  // FA V2
  fa_format_details?: IFAFormatDetails;
  fa_content?: AssessmentContent;
  fa_selected_section_number?: number;
  fa_all_chapters_data?: CourseIndexInfo;
  fa_selected_chapters?: CourseIndexInfo;
  /*
  export interface IFASettingsConfig {
    no_of_questions?: number;
    approximate_time?: number;
    overall_difficulty?: string;
    marking_scheme?: MarkingSchemeEnum;
    bloom_levels?: BloomLevelEnum[];
    question_type_marks?: QuestionTypeMarks[];
    question_type_count?: QuestionTypeCount;
    question_types?: Question_QuestionEnum[];
  }
  */
  fa_settings_config?: IFASettingsConfig;
  fa_created_section_test?: ModuleFilteredQuestionsV3;
  fa_multi_subject_info_hash?: string;
  fa_library_choice_creation?: IFALibChoiceData;
}

export interface IRequiredQuestionCountInfoForDifficultyLevel {
  noOfLowQuestions: number;
  noOfMediumQuestions: number;
  noOfHighQuestions: number;
}
export interface CustomUploadFileResponse {
  uploadFileData: CloudUpload;
  fileUploadStatus:
    | 'pending'
    | 'success'
    | 'Invalid Type'
    | 'Size Exceeded'
    | 'Upload Error';
  fileSize: number;
}

const initialState: IAssessmentFlowState = {
  assesment_creation_type: {
    modeOfConduction: ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP,
    markingScheme: MarkingSchemeEnum.MARKING_SCHEME_GENEO,
  },
  assesment_flow_data: undefined,
  chapter_topic_data: undefined,
  fa_selected_chapter_data: undefined,
  fa_assessment_config: undefined,
  fa_edit_step: undefined,
  qpg_selected_chapter_data: undefined,
  qpg_settings_config: undefined,
  generated_qpg_templates: undefined,
  qpg_edit_step: undefined,
  qpg_assessment_task: undefined,
  qpg_assessment_content: undefined,
  qpg_questions_sequence_info: undefined,
  qpg_questions_sequence_info_hash: undefined,
  qpg_multi_subject_info_hash: undefined,
  qpg_question_type_marks: undefined,
  qpg_question_module_map: undefined,
  selected_section_index_for_alternate: undefined,
  selected_question_index_for_alternate: undefined,
  selected_question_type_for_alternate: undefined,
  selected_chapter: undefined,
  selected_topic: undefined,
  //homework shifted state
  subjectwise_chapters_info: undefined,
  chapterwise_topic: undefined,
  chapter_resources: undefined,
  filtered_questions: undefined,
  questions_count: {
    noOfLowQuestions: 0,
    noOfMediumQuestions: 0,
    noOfHighQuestions: 0,
  },
  module_filtered_questions: undefined,
  assessment_instructions: [
    'Answer all questions to complete the Assessment assignment.',
    'Ensure Assessment completion by the specified Deadline.',
  ],
  custom_homework: undefined,
  draft_uploaded_files: [],
  qpg_search_questions_config: undefined,
  question_upload_filter: {
    value: 'all',
  },
  // manage_mode_of_conduction: ModeOfConductionEnum.MODE_OF_CONDUCTION_UNDEFINED,

  // QPG V2
  qpg_format_details: {
    selectedSubjectsAndMarks: [
      { subject: { name: '', id: 0 }, marks: undefined },
    ],
    selectedTemplates: [{ name: '', id: 0 }],
  },
  qpg_subsection_data: [],
  qpg_content: undefined,
  qpg_selected_section_index: undefined,
  qpg_created_section_test: undefined,
  qpg_selected_sub_section_index: undefined,
  qpg_chapter_ids_info_collection: undefined,

  // FA V2
  fa_format_details: { selectedSubjects: [{ name: '', id: 0 }] },
  fa_content: undefined,
  fa_selected_section_number: undefined,
  fa_all_chapters_data: undefined,
  fa_selected_chapters: undefined,
  fa_settings_config: undefined,
  fa_created_section_test: undefined,
  fa_multi_subject_info_hash: undefined,
  fa_library_choice_creation: undefined,
};

export const assessmentFlowSlice = createSlice({
  name: 'assessmentFlow',
  initialState,
  reducers: {
    setQuestionUploadFilter: (state, action) => {
      state.question_upload_filter = action.payload;
    },
    setAssessmentCreationType: (state, action) => {
      state.assesment_creation_type = action.payload;
    },
    resetAssessmentCreationType: (state) => {
      state.assesment_creation_type = initialState.assesment_creation_type;
    },
    setAssessmentData: (state, action) => {
      state.assesment_flow_data = action.payload;
    },
    setCourseIndexInfo: (state, action) => {
      state.chapter_topic_data = action.payload;
    },
    setFASelectedChapterData: (state, action) => {
      state.fa_selected_chapter_data = action.payload;
    },
    setFAAssessmentConfig: (state, action) => {
      state.fa_assessment_config = action.payload;
    },
    setFAEditStep: (state, action) => {
      state.fa_edit_step = action.payload;
    },
    setFAQuestionModuleMap: (
      state,
      action: PayloadAction<QuestionModuleMap[] | undefined>
    ) => {
      state.fa_question_module_map = action.payload;
    },
    setSelectedChapter: (state, action) => {
      state.selected_chapter = action.payload;
    },
    setQPGSelectedChapterData: (state, action) => {
      state.qpg_selected_chapter_data = action.payload;
    },
    setQPGSettingsConfig: (state, action) => {
      state.qpg_settings_config = action.payload;
    },
    setQPGEditStep: (state, action) => {
      state.qpg_edit_step = action.payload;
    },
    setQPGAssessmentTask: (
      state,
      action: PayloadAction<AssessmentTask | undefined>
    ) => {
      state.qpg_assessment_task = action.payload;
    },
    setQPGAssessmentContent: (
      state,
      action: PayloadAction<Question[] | undefined>
    ) => {
      state.qpg_assessment_content = action.payload;
    },
    setQPGQuestionsSequenceInfo: (
      state,
      action: PayloadAction<TaskInfo | undefined>
    ) => {
      state.qpg_questions_sequence_info = action.payload;
    },
    setQPGQuestionsSequenceInfoHash: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.qpg_questions_sequence_info_hash = action.payload;
    },
    setQPGMultiSubjectInfoHash: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.qpg_multi_subject_info_hash = action.payload;
    },
    setQPGAssessmentInstructionsHash: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.qpg_assessment_instructions_hash = action.payload;
    },
    setQPGQuestionTypeMarks: (
      state,
      action: PayloadAction<QuestionTypeMarks[] | undefined>
    ) => {
      state.qpg_question_type_marks = action.payload;
    },
    setQPGGeneratedTemplates: (state, action) => {
      state.generated_qpg_templates = action.payload;
    },
    setQPGQuestionModuleMap: (
      state,
      action: PayloadAction<QuestionModuleMap[] | undefined>
    ) => {
      state.qpg_question_module_map = action.payload;
    },
    setCurrentQPGTemplateInfo: (state, action) => {
      state.current_qpg_template_info = action.payload;
    },
    setSelectedTopic: (state, action) => {
      state.selected_topic = action.payload;
    },
    resetSelectedChapter: (state) => {
      state.selected_chapter = undefined;
    },
    resetSelectedTopic: (state) => {
      state.selected_topic = undefined;
    },
    resetAssessmentFlowState: (state) => {
      return initialState;
    },
    setLowQuestionsCount: (state, action) => {
      if (state.questions_count) {
        const type = action.payload.type;
        if (type === 'inc') {
          state.questions_count.noOfLowQuestions += 1;
        } else if (
          type === 'dec' &&
          state.questions_count.noOfLowQuestions > 0
        ) {
          state.questions_count.noOfLowQuestions -= 1;
        }
      }
    },
    setMediumQuestionsCount: (state, action) => {
      if (state.questions_count) {
        const type = action.payload.type;
        if (type === 'inc') {
          state.questions_count.noOfMediumQuestions += 1;
        } else if (
          type === 'dec' &&
          state.questions_count.noOfMediumQuestions > 0
        ) {
          state.questions_count.noOfMediumQuestions -= 1;
        }
      }
    },
    setHighQuestionsCount: (state, action) => {
      if (state.questions_count) {
        const type = action.payload.type;
        if (type === 'inc') {
          state.questions_count.noOfHighQuestions += 1;
        } else if (
          type === 'dec' &&
          state.questions_count.noOfHighQuestions > 0
        ) {
          state.questions_count.noOfHighQuestions -= 1;
        }
      }
    },
    setQuestionsCount: (
      state,
      action: { payload: ModuleFilteredQuestions | undefined }
    ) => {
      let question_list = undefined;
      if (action.payload) {
        question_list = JSON.parse(
          JSON.stringify(state.module_filtered_questions)
        );
      } else {
        question_list = state.module_filtered_questions
          ? JSON.parse(JSON.stringify(state.module_filtered_questions))
          : undefined;
      }
      const newCount = calculateQuestionsCount(question_list);
      state.questions_count = newCount;
    },
    setModuleFilteredQuestions: (state, action) => {
      state.module_filtered_questions = action.payload;
    },
    deleteModuleFilteredQuestionsById: (state, action) => {
      const questionIdToDelete = action.payload;
      if (state.module_filtered_questions?.questions) {
        state.module_filtered_questions.questions =
          state.module_filtered_questions.questions.filter(
            (q) => q.questionId !== questionIdToDelete
          );
      }
    },
    addModuleFilteredQuestion: (state, action) => {
      if (state.module_filtered_questions) {
        state.module_filtered_questions.questions.push(action.payload);
      }
    },
    setSubjectWiseChaptersInfo: (
      state,
      action: { payload: FetchSubjectChapterInfoV2 | undefined }
    ) => {
      // console.log('payload', action.payload);
      state.subjectwise_chapters_info = action.payload;
    },

    setChapterWiseTopicInfo: (state, action) => {
      state.chapterwise_topic = action.payload;
    },

    setChapterResources: (state, action) => {
      state.chapter_resources = action.payload;
    },
    setFilteredQuestions: (state, action) => {
      state.filtered_questions = action.payload;
    },
    setSelectedTasksInfo: (state, action) => {
      state.selected_tasks_info = action.payload;
    },
    setSubmittedAssessmentId: (state, action) => {
      state.submitted_assessment_id = action.payload;
    },
    setCreatedAssessmentDetails: (state, action) => {
      state.created_assessment_details = action.payload;
    },
    setCreatedAssessmentStatus: (state, action) => {
      state.createdAssessmentStatus = action.payload;
    },
    resetCreatedAssessmentStatus: (state) => {
      state.createdAssessmentStatus = initialState.createdAssessmentStatus;
    },
    setFetchedAssessmentDetails: (state, action) => {
      state.fetched_assessment_details = action.payload;
    },
    setQuestionStats: (state, action) => {
      state.questions_stats = action.payload;
    },
    setAssessmentInstructions: (state, action) => {
      state.assessment_instructions = action.payload;
    },
    setCustomHomework: (state, action) => {
      state.custom_homework = action.payload;
    },
    setDraftUploadedFiles: (state, action) => {
      state.draft_uploaded_files = action.payload;
    },
    setTemporarySectionIds: (state, action) => {
      state.temporary_section_ids = action.payload;
    },
    resetAssessmentInstructions: (state) => {
      state.assessment_instructions = initialState.assessment_instructions;
    },
    resetFetchedAssessmentDetails: (state) => {
      state.fetched_assessment_details =
        initialState.fetched_assessment_details;
    },
    resetSelectedTasksInfo: (state) => {
      state.questions_count = initialState.questions_count;
    },

    resetCustomHomework: (state) => {
      state.custom_homework = initialState.custom_homework;
    },
    resetDraftUploadedFiles: (state) => {
      state.draft_uploaded_files = initialState.draft_uploaded_files;
    },
    resetFASelectedChapterData: (state) => {
      state.fa_selected_chapter_data = initialState.fa_selected_chapter_data;
    },
    resetFAAssessmentConfig: (state) => {
      state.fa_assessment_config = initialState.fa_assessment_config;
    },
    setSelectedSectionIndexForAlternateQuestion: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.selected_section_index_for_alternate = action.payload;
    },
    setSelectedQuestionIndexForAlternateQuestion: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.selected_question_index_for_alternate = action.payload;
    },
    setSelectedQuestionTypeForAlternateQuestion: (
      state,
      action: PayloadAction<Question_QuestionEnum | undefined>
    ) => {
      state.selected_question_type_for_alternate = action.payload;
    },
    setAssessmentLibraryFilter: (
      state,
      action: PayloadAction<IAssessmentLibraryFilter | undefined>
    ) => {
      state.assessment_library_filter = action.payload;
    },
    setQPGSearchQuestionsConfig: (
      state,
      action: PayloadAction<IQPGSeachQuestionsConfig | undefined>
    ) => {
      state.qpg_search_questions_config = action.payload;
    },

    // QPG V2
    setQPGFormatDetails: (
      state,
      action: PayloadAction<IQPGFormatDetails | undefined>
    ) => {
      state.qpg_format_details = action.payload;
    },
    setQPGSubsectionData: (
      state,
      action: PayloadAction<SubSectionType[] | undefined>
    ) => {
      state.qpg_subsection_data = action.payload;
    },
    setQPGContent: (
      state,
      action: PayloadAction<AssessmentContent | undefined>
    ) => {
      state.qpg_content = action.payload;
    },
    setQPGSelectedSectionIndex: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.qpg_selected_section_index = action.payload;
    },
    setQPGSelectedSectionNumber: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.qpg_selected_section_number = action.payload;
    },
    setQPGCreatedSectionTest: (
      state,
      action: PayloadAction<ModuleFilteredQuestionsV3 | undefined>
    ) => {
      state.qpg_created_section_test = action.payload;
    },
    setQPGSelectedSubSectionIndex: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.qpg_selected_sub_section_index = action.payload;
    },
    setQPGChapterIdsInfoCollection: (
      state,
      action: PayloadAction<
        { [sectionNo: number]: ChapterIdsInfo[] } | undefined
      >
    ) => {
      state.qpg_chapter_ids_info_collection = action.payload;
    },

    // FA V2
    setFaFormatDetails: (
      state,
      action: PayloadAction<IFAFormatDetails | undefined>
    ) => {
      state.fa_format_details = action.payload;
    },
    setFAContent: (
      state,
      action: PayloadAction<AssessmentContent | undefined>
    ) => {
      state.fa_content = action.payload;
    },
    setFASelectedSectionNumber: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.fa_selected_section_number = action.payload;
    },
    setFAAllChaptersData: (
      state,
      action: PayloadAction<CourseIndexInfo | undefined>
    ) => {
      state.fa_all_chapters_data = action.payload;
    },
    setFASelectedChapters: (
      state,
      action: PayloadAction<CourseIndexInfo | undefined>
    ) => {
      state.fa_selected_chapters = action.payload;
    },
    setFASettingsConfig: (
      state,
      action: PayloadAction<IFASettingsConfig | undefined>
    ) => {
      state.fa_settings_config = action.payload;
    },
    setFACreatedSectionTest: (
      state,
      action: PayloadAction<ModuleFilteredQuestionsV3 | undefined>
    ) => {
      state.fa_created_section_test = action.payload;
    },
    setFAMultiSubjectInfoHash: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.fa_multi_subject_info_hash = action.payload;
    },
    setFALibraryChoiceCreation: (
      state,
      action: PayloadAction<IFALibChoiceData | undefined>
    ) => {
      state.fa_library_choice_creation = action.payload;
    },
  },
});

export const {
  setQuestionUploadFilter,
  setAssessmentCreationType,
  resetAssessmentCreationType,
  setAssessmentData,
  setCourseIndexInfo,
  setSelectedChapter,
  setSelectedTopic,
  setFAAssessmentConfig,
  resetFAAssessmentConfig,
  setFAEditStep,
  setQPGSelectedChapterData,
  setQPGSettingsConfig,
  setQPGEditStep,
  setQPGGeneratedTemplates,
  setQPGQuestionModuleMap,
  setQPGAssessmentTask,
  setQPGAssessmentContent,
  setQPGQuestionsSequenceInfo,
  setQPGQuestionsSequenceInfoHash,
  setQPGAssessmentInstructionsHash,
  setQPGMultiSubjectInfoHash,
  setQPGQuestionTypeMarks,
  setCurrentQPGTemplateInfo,
  setSelectedSectionIndexForAlternateQuestion,
  setSelectedQuestionIndexForAlternateQuestion,
  setSelectedQuestionTypeForAlternateQuestion,
  resetSelectedChapter,
  resetSelectedTopic,
  resetAssessmentFlowState,
  setLowQuestionsCount,
  setMediumQuestionsCount,
  setHighQuestionsCount,
  setModuleFilteredQuestions,
  setSubjectWiseChaptersInfo,
  setChapterWiseTopicInfo,
  setChapterResources,
  setFilteredQuestions,
  setSelectedTasksInfo,
  setSubmittedAssessmentId,
  setCreatedAssessmentDetails,
  deleteModuleFilteredQuestionsById,
  addModuleFilteredQuestion,
  resetSelectedTasksInfo,
  setCreatedAssessmentStatus,
  setFetchedAssessmentDetails,
  setQuestionStats,
  setCustomHomework,
  setDraftUploadedFiles,
  resetCreatedAssessmentStatus,
  resetFetchedAssessmentDetails,
  setQuestionsCount,
  setAssessmentInstructions,
  setTemporarySectionIds,
  resetAssessmentInstructions,
  resetCustomHomework,
  resetDraftUploadedFiles,
  setFASelectedChapterData,
  resetFASelectedChapterData,
  setAssessmentLibraryFilter,
  setFAQuestionModuleMap,
  setQPGSearchQuestionsConfig,

  // QPG V2
  setQPGFormatDetails,
  setQPGSubsectionData,
  setQPGContent,
  setQPGSelectedSectionIndex,
  setQPGSelectedSectionNumber,
  setQPGCreatedSectionTest,
  setQPGSelectedSubSectionIndex,
  setQPGChapterIdsInfoCollection,

  // FA V2
  setFaFormatDetails,
  setFAContent,
  setFASelectedSectionNumber,
  setFAAllChaptersData,
  setFASelectedChapters,
  setFASettingsConfig,
  setFACreatedSectionTest,
  setFAMultiSubjectInfoHash,
  setFALibraryChoiceCreation,
} = assessmentFlowSlice.actions;

export default assessmentFlowSlice.reducer;
